import axios from "axios"
import { SERVER_BASE_URL } from "../../constants/constants"
import authHeader from "../authentication/authHeader"

export const EquationsService = {
    /**
     * Fetches JSON file of the constants.
     * @param server Name of the server.
     */
    async getConstantsFile(token: string) {
        const url = SERVER_BASE_URL + "api/equations/constants";
        return axios.get(url, { headers: authHeader(token) });
    },

    /**
     * Uploads JSON file of constants to the server.
     * @param token 
     * @param server 
     * @param content 
     * @returns 
     */
    async uploadConstantsFile(token: string, content: string) {
        const url = SERVER_BASE_URL + "api/equations/constants";
        return axios.post(url, content, {
            headers: {
                'x-auth-token': token,
                'Content-Type': "application/json",
            },
        });
    },

    async getParametersFile(token: string) {
        const url = SERVER_BASE_URL + "api/equations/parameters";
        return axios.get(url, { headers: authHeader(token)});
    },

    async uploadParametersFile(token: string, content: string | ArrayBuffer) {
        const url = SERVER_BASE_URL + "api/equations/parameters";
        return axios.post(url, content, {
            headers: {
                'x-auth-token': token,
                'Content-Type': "application/x-www-form-urlencoded"
            }
        });
    },

    async getGameDefaultValuesFile(token: string) {
        const url = SERVER_BASE_URL + "api/game/default";
        return axios.get(url, { headers: authHeader(token) });
    },

    async uploadGameDefaultValuesFile(token: string, content: string) {
        const url = SERVER_BASE_URL + "api/game/default";
        return axios.post(url, content, {
            headers: {
                'x-auth-token': token,
                'Content-Type': "application/json",
            },
        });
    },

    async getGameConfigFile(token: string) {
        const url = SERVER_BASE_URL + "api/game/config";
        return axios.get(url, { headers: authHeader(token) });
    },

    async uploadGameConfigFile(token: string, content: string) {
        const url = SERVER_BASE_URL + "api/game/config";
        return axios.post(url, content, {
            headers: {
                'x-auth-token': token,
                'Content-Type': "application/json",
            },
        });
    },

    async getGlobalDefaultValues() {
        const url = SERVER_BASE_URL + "api/home";
        return axios.get(url);
    },

    async setGlobalDefaultValues(token: string, content: string) {
        const url = SERVER_BASE_URL + "api/home";
        return axios.post(url, content, {
            headers: {
                'x-auth-token': token,
                'Content-Type': "application/json",
            }
        });
    }
}